import { UserContext } from "../Definitions/UserContext";

import LayoutNode from "../Definitions/LayoutNode";
import { AsyncAjaxGet, AsyncAjaxPatch, AsyncAjaxPost } from "./AsyncAjaxService";
import { utils } from "../../utils/Utils";
import { getCookie } from "./CookieUtils";
import { GetPreviewCluster } from "./WindowUtils";
import { ProductPlaceHolder } from "../Binding/BusinessPlaceholderData";


const VagaroAPIEnum = {
    getMerchantRoot: "merchants/",
    getBusinessHours: "/workinghours",
    getSocialLinks: "/sociallink",
    getServices: "/services",
    getServiceCategories: "/services/servicecategory",
    getClassCategories: "/classes/classcategory",
    getFacility: "/facilities",
    getReviews: "/reviews",
    getStaff: "/staffs",
    getProducts:"/products/search",
    getProductTypes: "/products/producttype",
    getProductCategories:"/products/categorys",
    getProductBrands: "/products/brand",
    getPhotos: "/photos",
    getDailyDeals: "/dailydeals",
    GetGiftCertificates: "/giftcards",
    getBusinessMap: "/maps",
    getBusinessMemberships: "/memberships",
    getBusinessPackages: "/packages",
    getReviewPercentage: "/reviews/reviewpercentage",
    getProductDetails: "/products/detail",
    getProductBundleDetails: "/products/bundle/",
    getCartCount: "/addtocart/getcartcount",
    getPromoCodes: "/promotions/discount",
    updateToken: "Token/generatetoken",
    getForms: "/form",
    getFormList: "/form/list",
    getBusinessLogo: "/businesslogo",
    getBusinessLocation: "mysite/distance",
    getBusinessName: "mysite/merchantname",
    getHouseCallCity: "mysite/housecallcities",
    getClustorBusinessData: "mysite/clustorbusinessdata",
    getBusinessHeroNickName: "mysite/nickname",
    getListingOnlyBusinesses: "mysite/getlistingonlybusinesses",
    getAdminServices:"mysite/getadminservices",
};


async function AsyncGetBusinessInformation(siteData: UserContext, url: string, onComplete?: Function, onFailure?: Function) {

    await ValidateToken(siteData);

    await AsyncAjaxGet(
        url,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                const newData = data?.data?.data ?? null;
                onComplete(newData);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        },
        siteData.businessId
    );
}


export async function AsyncGetLocation(siteData: UserContext, latitude: number, longitude: number, IpAddress: string, url: string, isLocationControl:boolean, GetLocation_Success?: Function, GetLocation_Fail?: Function) {

    await ValidateToken(siteData);
    const Requestdata:any = {};
    Requestdata.PromoCodeIDs = "";
    Requestdata.latitude = (utils.isNotEmptyOrWhiteSpace(latitude) ? latitude : 0);
    Requestdata.longitude = (utils.isNotEmptyOrWhiteSpace(longitude) ? longitude : 0);
    Requestdata.IpAddress = (utils.isNotEmptyOrWhiteSpace(IpAddress) ? IpAddress : "");
    Requestdata.MongoJSON = "";
    Requestdata.IsGroupCall = false;
    Requestdata.IsLocationControl = isLocationControl;

    await AsyncAjaxPost(
        url,
        Requestdata,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (GetLocation_Success) {
                const newData = data?.data?.data ?? null;
                GetLocation_Success(newData);
            }
        },
        function OnError(data: any) {
            if (GetLocation_Fail) {
                GetLocation_Fail(data);
            }

        },
        siteData.sitebid
    );
}

async function AsyncGetBusinessHouseCallCity(siteData: UserContext, businessId: string, url: string, GetBusinessHouseCallCity_Success?: Function, GetBusinessHouseCallCity_Fail?: Function) {

    await ValidateToken(siteData);

    await AsyncAjaxGet(
        url,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (GetBusinessHouseCallCity_Success) {
                const newData = data?.data?.data ?? null;
                GetBusinessHouseCallCity_Success(newData);
            }
        },
        function OnError(data: any) {
            if (GetBusinessHouseCallCity_Fail) {
                GetBusinessHouseCallCity_Fail(data);
            }

        },
        businessId
    );
}

export async function GetPromoCodes(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = userContext.businessId + VagaroAPIEnum.getPromoCodes;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}


// const ids = [
// "9sKNxELkCB5b5eNkKkqfVw==","RYNV8Yoq0H0fGdwNv7chvA==","NDHh3blWleM~5~6D7sJQfQ==","9hRhjIfnFiN5PETjoXL3lw==",
// "Wv7doPobVsu~IDHL4hHHzg=="


// ]




export async function GetProductDetails(userContext: UserContext,masterId:string, productId: string, onComplete?: Function, onFailure?: Function) {


    let params = `?InventoryId=${productId}&InventoryMasterId=${masterId}`;


    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot+userContext.businessId+ VagaroAPIEnum.getProductDetails + params;

    await AsyncAjaxGet(url,userContext.accessToken,(data:any)=>{

        if(data?.data?.message=="No Record Found"){

            let copy = {...ProductPlaceHolder} as any
            copy.isStenciled = false;
            copy.noRecordsFound = true;
            onComplete&&onComplete(copy);
        }
        else if(onComplete)
            onComplete(data?.data?.data);
    },onFailure)//userContext.businessId);

}

export async function GetProductBundleDetails(userContext: UserContext, productId: string, onComplete?: Function, onFailure?: Function) {

    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getProductBundleDetails + productId;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

async function CommonReponse(siteData: UserContext, onComplete?: Function, onFailure?: Function) {
    if (onComplete) {
        onComplete([]);
    }
}

async function GetBusinessServices(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    if(!userContext.allowMultiLoc)
        userContext.allowMultiLoc = false;
    await ValidateToken(userContext);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    var cookieValue = getCookie("Referral") != "" ? true : false;
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getServices + "?IsEditor=" + IsEditor + "&Referral=" + cookieValue + "&IsAllowMultilocation=" + userContext.allowMultiLoc;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

async function GetBusinessServiceCategories(userContext: UserContext, businessId: string, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);

    const url = VagaroAPIEnum.getMerchantRoot + businessId + VagaroAPIEnum.getServiceCategories;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}


async function GetBusinessClassCategories(userContext: UserContext, businessId: string, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);

    const url = VagaroAPIEnum.getMerchantRoot + businessId + VagaroAPIEnum.getClassCategories;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBusinessMap(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getBusinessMap;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function getProductBrands(userContext: UserContext, onComplete?: Function, onFailure?: Function, filter: string[] = []) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getProductBrands;
    const content = {
        "BrandlistFilter": filter
    }


    await AsyncAjaxPost(url, JSON.stringify(content), userContext.accessToken, onComplete, onFailure);
}

export async function getProductTypes(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getProductTypes;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function getProductCategories(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot +userContext.businessId +VagaroAPIEnum.getProductCategories;
    await AsyncAjaxGet(url, userContext.accessToken, (data:any)=>{onComplete&&onComplete(data?.data?.data)}, onFailure);

}


export async function ValidateToken(userContext: UserContext) {

    let expire = (userContext.tokenExpiresAt ?? 0) - 1000;

    let current = Date.now();

    // console.log("Validating...",userContext);
    // console.log(new Date(expire??0)," vs current:",new Date(current));

    if (!expire || current >= expire) {

        await UpdateAccessToken(userContext);

    }



    return true;
}

export async function GetBusinessLogoURL(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {




    await ValidateToken(siteData);

    const rootURL = "merchants/" + siteData.businessId + VagaroAPIEnum.getBusinessLogo;
    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {

            let imgPath = data?.data?.data?.imagePath ?? "";

            if (onComplete) {
                onComplete(imgPath);
            }
        },
        function OnError(data: any) {

            if (onFailure) {
                onFailure("");
            }
        }
    );
}

export async function UpdateAccessToken(userContext: UserContext) {

    userContext.accessToken = "eyJhbGciOiJSUzI1NiIsImtpZCI6IkQ3RTVCRkQ5QTg0REQ4QTgxQTU0QTY0NzlCOEQyNDRGREM0MDYxNTRSUzI1NiIsInR5cCI6ImF0K2p3dCIsIng1dCI6IjEtV18yYWhOMktnYVZLWkhtNDBrVDl4QVlWUSJ9.eyJuYmYiOjE3NDMxMzY5NDUsImV4cCI6MTc0MzE0MDU0NSwiaXNzIjoiaHR0cHM6Ly9hcy1kZXYtMDQtaWRzLmF6dXJld2Vic2l0ZXMubmV0IiwiY2xpZW50X2lkIjoiYTRlNTU0ODUtYmY0Zi00ZmU4LTk4ZjEtZjU1NTc0YjlhYmJkIiwiaWF0IjoxNzQzMTM2OTQ1LCJzY29wZSI6WyJ2YWdhcm9fdjJfYXBpIl19.RQgokH6oPgCNED2YjK8jzRu8SM96AEncUfdIsyPu4uaBnDO3DxqLxC4S8mfLlNovHEA7W4GNAxuj3zn4j54UE20e0AM6rOlRqR-KsAAAv6oMeMhTlaIOp5A8wSZ8GxDRCId71aMrUKze-mFZIVSE4mzavxKbpdBtuQuzwPcjdv4izqxpUPr5U4DsQYeDYseNBgq_pXV2efyJAS3TVDJU1r99ViOd-8fxj37VwzqXVErkr83XG7QZKP3Y9VnhJjRw6-2kzHbT0InMXcfxJysmNMDtbI6NM9WQQOsMkcSTlGxJlbdD-pC3G1L7hbzGRCb7vhuUtKGOoZHlT0MSo3BImQ";
    let expiresIn = 3600;
    let newDate = new Date();
    userContext.tokenExpiresAt = newDate.getTime() + (expiresIn / 2) * 1000;

    /* const url = VagaroAPIEnum.updateToken;
    let timeout = (window as any).vwbaccesstimeout;
    if (timeout && Date.now() < timeout) {
        return;
    }

    (window as any).vwbaccesstimeout = Date.now() + 10000;

    await AsyncAjaxPost(
        url,
        "",
        userContext.accessToken,
        function onSuccess(data: any) {

            const token = data?.data?.access_token;
            const expiresIn = data?.data?.expires_in;
            if (token && expiresIn) {
                userContext.accessToken = token;
                const newDate = new Date();
                userContext.tokenExpiresAt = newDate.getTime() + (expiresIn / 2) * 1000;
            }
            else {
                console.warn("Failed to update access token");
            }
        },
        function OnError(data: any) {
            console.warn("Failed to update access token", data);
        }

    ) */

}


export async function GetBusinessProducts(userContext: UserContext, onComplete?: Function, onFailure?: Function, pageNumber = 1, pageSize = 50, productTypes:string = "", brandFilters: string[] = [],optionFilters:string[] = [],optionSplitString="|:|", searchText = "") {

    if(!userContext.allowMultiLoc)
        userContext.allowMultiLoc = false;

    // var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const url = VagaroAPIEnum.getMerchantRoot+userContext.businessId+ VagaroAPIEnum.getProducts;
    await ValidateToken(userContext);

    let optionString = "";
    for(let i = 0;i<optionFilters.length;i++){

        if(i>0)
            optionString += ",";
        let split = optionFilters[i].split(optionSplitString);

         optionString += `{\"${split[0].replace(/"/g, '\\"')}\":\"${split[1].replace(/"/g, '\\"')}\"}`;

    }

    const body = {

            "pageIndex" : pageNumber,
            "pageSize" : pageSize,
            "productTypeList" : productTypes,
            "brandIds" : brandFilters.join(","),
            "searchText" : searchText,
            "options" :optionString,


    }
    await AsyncAjaxPost(
        url,
        JSON.stringify(body),
        userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                const newData = data?.data?.data ?? null;
                onComplete(newData);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );
}

export async function GetGiftCertificates(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    if(!userContext.allowMultiLoc)
        userContext.allowMultiLoc = false;
    await ValidateToken(userContext);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.GetGiftCertificates + "?IsEditor=" + IsEditor + "&IsAllowMultilocation=" + userContext.allowMultiLoc;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function getDailyDeals(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getDailyDeals;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBusinessGallery(userContext: UserContext, onComplete?: Function, onFailure?: Function, pageNumber = 1, pageSize = 500) {
    await ValidateToken(userContext);
    var url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getPhotos + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    var LoginDetails = utils.ReadCookie();
    if (LoginDetails.EncUid !== undefined && LoginDetails.EncUid !== "" && LoginDetails.EncUid !== null && LoginDetails.EncUid !== 0) {
        url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getPhotos + "?EncUserID=" + LoginDetails.EncUid + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    }
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBusinessDetails(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}



export async function GetBusienssHours(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getBusinessHours;
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetFacilityInformation(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getFacility;
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetBusinessSocialLinks(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getSocialLinks;
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetBusinessReviews(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void, pageSize = 20, page = 1, sort = "1", type = "1", SPID = "U2FsdGVkX18EI4k80FtcVtq4PzxA94OPqaGqyI1vxNM=") {
    await ValidateToken(siteData);
    var url;
    if (SPID != "U2FsdGVkX18EI4k80FtcVtq4PzxA94OPqaGqyI1vxNM=") {
        url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getReviews + "?pageSize=" + pageSize + "&pageNumber=" + page + "&filterType=" + type + "&sortType=" + sort + "&SPID=" + SPID;
    }
    else {
        url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getReviews + "?pageSize=" + pageSize + "&pageNumber=" + page + "&filterType=" + type + "&sortType=" + sort;
    }
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetBusinessStaff(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getStaff;
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetBusinessMemberships(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    if(!userContext.allowMultiLoc)
        userContext.allowMultiLoc = false;
    await ValidateToken(userContext);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getBusinessMemberships + "?IsEditor=" + IsEditor + "&IsAllowMultilocation=" + userContext.allowMultiLoc;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBuseinssesInDistanceForRenters(userContext:UserContext,latitude:number,longitude:number, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessLocation;
    await AsyncGetLocation(userContext, latitude, longitude, "", url, true, onComplete, onFailure);

}

export async function GetBusinessLocation(userContext: UserContext, isLocationControl:boolean, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessLocation;
    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(async function (position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            await AsyncGetLocation(userContext, latitude, longitude, "", url, isLocationControl, onComplete, onFailure);
        }, await function (error) {
            fetch('https://geolocation-db.com/json/')
                .then(response => response.json())
                .then(data => {
                    AsyncGetLocation(userContext, 0, 0, data.IPv4, url, isLocationControl, onComplete, onFailure);
                })
                .catch(error => AsyncGetLocation(userContext, 0, 0, "", url, isLocationControl, onComplete, onFailure))
        });
    }
    else {
        await fetch('https://geolocation-db.com/json/')
            .then(response => response.json())
            .then(data => {
                AsyncGetLocation(userContext, 0, 0, data.IPv4, url, isLocationControl, onComplete, onFailure);
            })
            .catch(error => AsyncGetLocation(userContext, 0, 0, "", url, isLocationControl, onComplete, onFailure))
    }
}

export async function GetBusinessName(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessName + "?IsEditor=" + IsEditor;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetHouseCallCity(userContext: UserContext, businessId: string, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getHouseCallCity;
    await AsyncGetBusinessHouseCallCity(userContext, businessId, url, onComplete, onFailure);
}


export async function GetBusinessPackages(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    if(!userContext.allowMultiLoc)
        userContext.allowMultiLoc = false;
    await ValidateToken(userContext);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getBusinessPackages + "?IsEditor=" + IsEditor + "&IsAllowMultilocation=" + userContext.allowMultiLoc;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBusinessReviewPecentage(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + userContext.businessId + VagaroAPIEnum.getReviewPercentage;
    await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
}

export async function GetBusinessCart(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    var LoginDetails = utils.ReadCookie();

    var encsitebid = "";
    if (userContext.sitebid !== undefined && userContext.sitebid !== null && userContext.sitebid !== "") {
        encsitebid = userContext.sitebid;
    } else {
        encsitebid = userContext.businessId;
    }

    if (LoginDetails.EncUid !== undefined && LoginDetails.EncUid !== "" && LoginDetails.EncUid !== null) {
        const url = encsitebid + VagaroAPIEnum.getCartCount + "?EncUid=" + LoginDetails.EncUid;
        await AsyncGetBusinessInformation(userContext, url, onComplete, onFailure);
    }
    else {
        if (onComplete) {
            onComplete("0");
        }
    }

}

export async function GetBusienssForm(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + siteData.businessId + VagaroAPIEnum.getForms + "/" + (siteData.formid == "1" ? "659fc093145116743f6fd103" : (utils.isNotEmptyOrWhiteSpace(siteData.formid) ? siteData.formid : "659fc093145116743f6fd103"));
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);
}

export async function GetBusinessFormList(siteData: UserContext, location: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    await ValidateToken(siteData);
    const url = VagaroAPIEnum.getMerchantRoot + location + VagaroAPIEnum.getFormList;
    await AsyncGetBusinessInformation(siteData, url, onComplete, onFailure);

}


export async function getClustorBusinessData(userContext: UserContext, Operation:string, Name:string, Category:string, MultiGroupString:string, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getClustorBusinessData;
    const content = {
        "Operation": Operation,
        "Name": Name,
        "Category":Category,
        "MultiGroupString" : MultiGroupString
    }
    await AsyncAjaxPost(url, JSON.stringify(content), userContext.accessToken, onComplete, onFailure,userContext.businessId);
}

export async function GetBusinessHero_NickName(siteData: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(siteData);
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    let url = "";
    let previewCluster =GetPreviewCluster();

    if(previewCluster&&previewCluster.length>0){
        url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessHeroNickName + "?IsEditor=false&NickName=" + encodeURIComponent(previewCluster);
    }

    else if(IsEditor) {
        url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessHeroNickName + "?IsEditor=true";
    }
    else {
        url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getBusinessHeroNickName + "?IsEditor=false&NickName=" + encodeURIComponent(siteData.nickname??"");
    }
    await AsyncAjaxGet(
        url,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                const newData = data?.data?.data ?? null;
                onComplete(newData);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        },
        siteData.businessId
    );

}


export async function GetListingOnlyBusinesses(siteData: UserContext, onComplete?: Function, onFailure?: Function,pageNumber?:string,pageSize?:string,search?:string,serviceSearch?:string, ignoreNickName?:boolean,forceNickName?:string, bType?:any[]) {
    await ValidateToken(siteData);
    let IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;



    let previewCluster =GetPreviewCluster();
    let url = "";

    //default to page 1 and 100 items per page to avoid server parsing error of empty strings
    let Editor = false;
    let nickName = "";
    let pgno =  "1";
    let pgsize = "100";
    let searchtx = "";
    url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getListingOnlyBusinesses;
    if(IsEditor ){
        Editor = true;
        pgno = (pageNumber&&pageSize)?pageNumber : "1";
        pgsize = (pageNumber&&pageSize)?pageSize : "100";
        //url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getListingOnlyBusinesses + "?IsEditor=true"+pageParams;
    }
    else if(forceNickName && forceNickName.length>0){
        nickName =  encodeURIComponent(forceNickName)
        Editor = false;
        //url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getListingOnlyBusinesses + "?IsEditor=false&NickName=" +nickName;
    }

    else if(previewCluster&&previewCluster.length>0){
        if(!ignoreNickName){
            let previewCluster =GetPreviewCluster();
            nickName = encodeURIComponent(previewCluster)
        }
        Editor = false;

        //url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getListingOnlyBusinesses + "?IsEditor=false&NickName=" +nickName;
    }

    else {

        if(!ignoreNickName){
            nickName =  encodeURIComponent(siteData.nickname??"")
        }
        Editor = false;
        pgno = (pageNumber&&pageSize)?pageNumber : "1";
        pgsize = (pageNumber&&pageSize)?pageSize : "100";
        searchtx = (search? search:"");
        //url =  VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getListingOnlyBusinesses + "?IsEditor=false&NickName=" + nickName+pageParams + (search?"&SearchText="+search:"");
    }

    const Requestdata:any = {};
    Requestdata.IsEditor = Editor;
    Requestdata.NickName = nickName;
    Requestdata.PageNumber = pgno;
    Requestdata.PageSize = pgsize;
    Requestdata.SearchText = searchtx;
    Requestdata.bType = bType;
    if(serviceSearch)
        Requestdata.SearchService = serviceSearch;

    await AsyncAjaxPost(
        url,
        Requestdata,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                const newData = data?.data?.data ?? null;
                onComplete(newData);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        },
        siteData.businessId
    );

}

export async function GetAdminServices(userContext: UserContext, onComplete?: Function, onFailure?: Function) {

    await ValidateToken(userContext);
    const url = VagaroAPIEnum.getMerchantRoot + VagaroAPIEnum.getAdminServices;
    AsyncAjaxGet(url,userContext.accessToken,(data:any)=>{
        onComplete&&onComplete(data?.data?.data);
    },(data:any)=>{
        onFailure&&onFailure(data);
    },userContext.businessId,userContext.userId);


}

export async function GetCommonReponse(userContext: UserContext, onComplete?: Function, onFailure?: Function) {
    await ValidateToken(userContext);
        await CommonReponse(userContext, onComplete, onFailure);
}

export { GetBusinessServices, GetBusinessServiceCategories, GetBusinessClassCategories };